import { Grid } from '@material-ui/core';
import {
  EntityAboutCard,
  EntityHasSystemsCard,
  EntityLayout,
  EntityLinksCard,
} from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';

import { EntityMarkdownCard } from '../EntityMarkdown/EntityMarkdownCard';
import { EntityWarningContent } from './EntityWarningContent';

export const DomainEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <EntityWarningContent />
        <Grid item md={6} xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <EntityAboutCard />
            </Grid>
            <Grid item xs={12}>
              <EntityLinksCard />
            </Grid>
            <Grid item xs={12}>
              <EntityMarkdownCard />
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={6} xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <EntityCatalogGraphCard height={400} />
            </Grid>
            <Grid item xs={12}>
              <EntityHasSystemsCard />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
